import { useEffect }              from 'react';
import { store }                  from 'index';
import { groupUrl }               from 'utils/constants'
import { GET_USER_ACTIVITY_SAGA } from 'actions';

const useGetUserActivity = (guest: boolean) => {

    const state = store.getState();
    const { userInfo, dataUpdateState } = state.data;

    useEffect(() => {

        if ( groupUrl || guest || !userInfo.userEmail.length || dataUpdateState.activity === true ) {
          return
        }
         store.dispatch(GET_USER_ACTIVITY_SAGA({ userEmail: userInfo.userEmail }));
    
      },[ userInfo.userEmail, dataUpdateState.activity, guest ])


}
export default useGetUserActivity;

